// Where he sits when a place has a seat, rather than on the ground in
// front of it, and which way he faces at a place he stands at.
//
// The sim is flat: it walks him to a place's stand spot and starts the
// action there, and the viewer owns his height (ServerNPCBridge snaps him
// to the terrain every frame). A bench he asked for, sat in front of on
// the paving, is not the bench he asked for. So while he is using a place
// with a seat, the viewer moves him from the stand spot onto the seat,
// lifts him by its height and turns him to face the way it faces; when he
// gets up he goes back to wherever the sim has him.
//
// The seats come off the models: each is a seat_<place> empty under its
// want's root in Kiwi_world.blend (the bench's seat, the bench in front
// of the keys),
// written into lib/world/wants.js by scripts/blender/wants-sync.py. Move a
// want there and its seat goes with it. Keyed here by the sim's entity id
// for the place (sim world/Wishes.js).

import { WANTS } from './wants.js'

export const SEATS = Object.fromEntries(
  Object.values(WANTS)
    .filter((w) => w.seat)
    .map(({ seat: { place, x, z, lift, rotY } }) => [`activity_granted_${place}`, { x, z, lift, rotY }]),
)

/** The seat he is on while doing this, or null when he is on his feet. */
export function seatFor(action, targetId) {
  if (action !== 'GRANTED' || !targetId) return null
  return SEATS[targetId] || null
}
